import { BaseModel } from "./base.model";

export enum UserStatusesEnum {
	"active" = 'active',
	"invited" = 'invited',
  "inactive" = 'inactive'
}

export interface UsersModel extends BaseModel {
	email: string,
	lastName?: string,
	firstName?: string,
	lastLogin?: Date,
	phone?: string,
	status?: UserStatusesEnum,
	role?: string
}
